/** @jsx jsx */

import { jsx, render, SelectionSet, Field, Variable, Mutation } from "graphql-jsx";
import { clients } from "utils/clients";
import { UuidScalar } from "GraphQL/Scalars";

type Option = Readonly<{
  uuid?: string;
}>;

export const DeletePlaylistGenre = async (option: Option) => {
  const $uuid = <Variable name="uuid" scalar={<UuidScalar isNullable />} value={option.uuid} />;

  const { query, variables } = render(
    <Mutation operationName="DELETE_PLAYLIST_GENRE">
      <SelectionSet
        name="deletePlaylist_genre_relation"
        alias="deletePlaylistGenre"
        argument={{
          where: {
            id: $uuid
          }
        }}
      >
        <Field name="id" />
      </SelectionSet>
    </Mutation>
  );
  type Data = Readonly<{
    deletePlaylistGenre: Readonly<{
      id: string;
    }>[];
  }>;
  return await clients.playlist.request<Data>(query, variables);
};
